import { render, staticRenderFns } from "./midpage.vue?vue&type=template&id=33b61da9&"
import script from "./midpage.vue?vue&type=script&lang=js&"
export * from "./midpage.vue?vue&type=script&lang=js&"
import style0 from "./midpage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports